import { SentimentName as EdgeSentimentName } from 'generated/graphql';
import { SentimentName } from 'v2/core/entities/fields';

export const mapSentimentNameToEdgeSentimentName = (
  sentiment: SentimentName | undefined,
) => {
  switch (sentiment) {
    case SentimentName.POSITIVE:
      return EdgeSentimentName.Positive;
    case SentimentName.NEGATIVE:
      return EdgeSentimentName.Negative;
    case SentimentName.NEUTRAL:
      return EdgeSentimentName.Neutral;
    default:
      return EdgeSentimentName.Invalid;
  }
};
